export default __webpack_public_path__ + "static/cutkilo_logo-bf95fe71a20391e1fbfe689ae0b2809b.svg";